import { useEffect } from 'react';

import { useAppDispatch, useAppSelector } from '../../app/hooks';
import Spinner from '../../components/common/Spinner';
import { getContentBlock } from '../../slices/content-block-slice';
import { colors } from '../../styles/GlobalStyles';
import { AnimatedDashboard } from '../../components';
import styled from 'styled-components';

export const TermsOfUse = () => {
  const dispatch = useAppDispatch();

  const { contentBlock, loading } = useAppSelector(
    (state) => state.contentBlock
  );

  useEffect(() => {
    dispatch(getContentBlock({ contentBlockId: 115, languageId: 1 }));
  }, [dispatch]);

  return (
    <AnimatedDashboard dark>
      {loading ? (
        <Spinner fullScreen={true} />
      ) : (
        <TermsOfUseWrapper>
          <div
            dangerouslySetInnerHTML={{
              __html: (contentBlock && contentBlock.content) || ''
            }}
          />
        </TermsOfUseWrapper>
      )}
    </AnimatedDashboard>
  );
};

export const TermsOfUseWrapper = styled.div<any>`
  max-width: 800px;
  margin: 0 auto;
  margin-top: 50px;

  p,
  h3 {
    margin-block-start: 1em;
    margin-block-end: 1em;
  }

  h1 {
    margin-block-start: 0.67em;
    margin-block-end: 0.67em;
  }

  h2 {
    margin-block-start: 0.83em;
    margin-block-end: 0.83em;
  }

  h4 {
    margin-block-start: 1.33em;
    margin-block-end: 1.33em;
  }
`;
